import React from "react";
import Typewriter from "typewriter-effect";

const Type = () => {
  return (
    <Typewriter
      options={{
        strings: [
          '2 years of industrial experience in frontend development',
          'React JS Development',
          'Next JS Development',
          'JavaScript Development',
          'Full Stack Enthusiast',
          'Transforming Ideas 💡 into Web UI 🚀 ',
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
};

export default Type;
